module.exports = __webpack_public_path__ + "static/media/west-blvd-aerial-closeup.c7b80d04.jpg";